import { Injectable } from '@angular/core';
import { Firestore, collection, query, where, getDocs } from '@angular/fire/firestore';
import { Observable, from } from 'rxjs';
import { map, catchError, tap } from 'rxjs/operators';
import { IBasicUser, IUser } from '../../../shared/models/users/user.model';
import { UserTypes } from '../../../shared/models/users/constants/user-types';


@Injectable({
  providedIn: 'root'
})


export class EmployeeCountService {
   private readonly collectionName = 'users';

  constructor(private firestore:Firestore) { }

 getEmployees(): Observable<IBasicUser[]> {
    const userCollection = collection(this.firestore, this.collectionName);
    const q = query(userCollection, where('userType', '==', UserTypes.EMPLOYEE));

    return from(getDocs(q)).pipe(
      map(querySnapshot => {
        return querySnapshot.docs.map(doc => ({

          ...doc.data()
        } as IBasicUser));
      })
    );
  }



    async getEmployeeCount(): Promise<number> {
        const userCollection = collection(this.firestore, this.collectionName);
        const requestsSnapshot = await getDocs(userCollection);
        return requestsSnapshot.size;
    }


}
